import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { ResponcePage } from 'projects/core/src/lib/misc/data/responce-page';
import { User } from 'projects/core/src/lib/login/data/user';

@JsonObject('UserResponcePage')
export class UserResponcePage extends ResponcePage {

    @JsonProperty([User], 'content')
    content: User[];
}